module.exports = __webpack_public_path__ + "img/btnDone.67defe0d.png";